import { z } from 'zod';
import {
  emailValidationSchema,
  optionalEmailValidationSchema,
} from '@upstart/commander-components/form-validators';

export function makeFormSchema({
  shouldSendEmail,
}: {
  shouldSendEmail: boolean;
}) {
  return z.object({
    email: shouldSendEmail
      ? emailValidationSchema
      : optionalEmailValidationSchema,
    customerMessage: z
      .string()
      .max(1500, 'Message cannot be more than 1500 characters'),
  });
}

export type FormSchema = z.infer<ReturnType<typeof makeFormSchema>>;
